import type React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import type { OnboardingData } from "@/pages/Onboarding";

interface OrganizationNameProps {
  formData: OnboardingData;
  updateFormData: (data: Partial<OnboardingData>) => void;
  handleNext: () => void;
}

export default function OrganizationName({
  formData,
  updateFormData,
  handleNext,
}: OrganizationNameProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    updateFormData({ [name]: value });
  };

  return (
    <div className="w-full min-w-md">
      <div className="w-full">
        <div className="space-y-6">
          <div className="space-y-2 w-full">
            <Label htmlFor="organization_name">Organization Name</Label>
            <Input
              id="organization_name"
              name="organization_name"
              placeholder="Acme Corporation"
              value={formData.organization_name}
              onChange={handleChange}
              autoFocus
              required
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleNext();
                }
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
